import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";

function Header() {
  const navigate = useNavigate();
  const [copyStatus, setCopyStatus] = useState({
    defaultLink: false,
    referralLink: false
  });
  const [profileData, setProfileData] = useState(null); // State for storing profile data

  const logout = () => {
    localStorage.removeItem('token');
    navigate('/login');
  };
  const origin = window.origin;

  const copyToClipboard = (id) => {
    const textToCopy = document.getElementById(id).value;
    navigator.clipboard.writeText(textToCopy).then(() => {
      if (id === "defaultLink") {
        setCopyStatus({ defaultLink: true, referralLink: false });
      } else if (id === "referralLink") {
        setCopyStatus({ defaultLink: false, referralLink: true });
      }

      // Reset the copied status after a short delay (2 seconds)
      setTimeout(() => {
        setCopyStatus({ defaultLink: false, referralLink: false });
      }, 2000);
    });
  };

    useEffect(() => {
      const fetchProfileData = async () => {
          try {
              const response = await fetch("https://api2b.pro/api/affilaite-profile", {
                method: "POST",
                  headers: {
                      Authorization: `Bearer ${localStorage.getItem("token")}`
                  }
              });
              const data = await response.json();
              setProfileData(data); // Store the fetched data
          } catch (error) {
              console.error("Error fetching profile data:", error);
          }
      };
      fetchProfileData();
  }, []);
  return (
    <header className="header">
      <div className="referral-code">
        <label>Default Player Sign-up Link</label>
        <div className="code-copy">
          <span className="ic-link" />
          <input
            className="form-control"
            type="text"
            value={`${profileData?.origin}/affiliate_code?affiliate_code=${profileData?.referral_code}`}
            readOnly="readonly"
            id="defaultLink"
          />
          <button className="btn-copy" onClick={() => copyToClipboard('defaultLink')}>
            Copy
          </button>
          {copyStatus.defaultLink && <div className="tips-txt">Copied</div>}
        </div>
      </div>
      
      <div className="referral-code">
        <label>Affiliate Referral Link</label>
        <div className="code-copy">
          <span className="ic-link" />
          <input
            className="form-control"
            type="text"
            value={`${origin}/referral_code?referral_code=${profileData?.referral_code}`}
            readOnly="readonly"
            id="referralLink"
          />
          <button className="btn-copy" onClick={() => copyToClipboard('referralLink')}>
            Copy
          </button>
          {copyStatus.referralLink && <div className="tips-txt">Copied</div>}
        </div>
      </div>

      <div className="referral-code-mobile" style={{ fontSize: '2.381643vw' }}>
        <div className="code-copy" id="mobileDefaultLink">
          <button className="btn-copy" style={{ width: 'auto' }} onClick={() => copyToClipboard('defaultLink')}>
          <span className="ic-link" />
<span>{copyStatus.defaultLink ? 'Copied' : 'Default Player Sign-up Link'}</span>

          </button>
          {copyStatus.defaultLink && <button className="btn-copied" style={{ width: 'auto' }}>Copied</button>}
        </div>
      </div>

      <div className="referral-code-mobile" style={{ fontSize: '2.381643vw' }}>
        <div className="code-copy" id="mobileReferralLink">
          <button className="btn-copy" style={{ width: 'auto' }} onClick={() => copyToClipboard('referralLink')}>
            <span className="ic-link" /><span>Affiliate Referral Link</span>
          </button>
          {copyStatus.referralLink && <button className="btn-copied" style={{ width: 'auto' }}>Copied</button>}
        </div>
      </div>

      <ul className="topnav">
        <li className="topnav-item">
         <Link to={'/profile'}>
         <button className="user-info">
            <span className="money">
              <span id="navBarMoney">৳</span> <span id="navBarAvailable">{profileData?.balance}</span>
            </span>
          </button>
         </Link>
        </li>
        <li className="topnav-item">
          <button className="btn-ic btn-outline-white" onClick={logout}>
            <span className="ic-logout" />
          </button>
        </li>
      </ul>
    </header>
  );
}

export default Header;
